import { createSlice } from "@reduxjs/toolkit";
import { dispatch } from "../store";
import axios from 'axios';

const initialState = {
  links: [],
  isLoading: false,
  error: null,
};

const slice = createSlice({
  name: 'personalLinks',
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    setLinks(state, action) { state.links = action.payload || []; state.isLoading = false; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload || 'Error'; },
  }
});

export const { startLoading, setLinks, hasError } = slice.actions;

export function fetchPersonalLinks() {
  const API_URL = process.env.REACT_APP_API_URL;
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      const res = await axios.get(`${API_URL}/api/dashboard/personal/links`);
      const data = res?.data?.data ?? res?.data ?? [];
      // Normalize to [{id,name,url,color,sortOrder,active}]
      const normalized = Array.isArray(data) ? data.map(x => ({
        id: x.id ?? x.ID ?? x.link_id,
        name: x.name ?? x.title,
        url: x.url ?? x.href,
        color: x.color || 'gold',
        sortOrder: x.sortOrder ?? x.sort_order ?? 0,
        active: typeof x.active === 'boolean' ? x.active : (x.active === 1 || x.active === '1'),
      })) : [];
      dispatch(slice.actions.setLinks(normalized));
    } catch (err) {
      console.error('fetchPersonalLinks failed', err);
      dispatch(slice.actions.hasError(err?.response?.data?.message || err.message));
    }
  };
}

// Fetch ALL links (active and inactive) for Settings UI
export function fetchPersonalLinksAll() {
  const API_URL = process.env.REACT_APP_API_URL;
  return async () => {
    try {
      dispatch(slice.actions.startLoading());
      // Settings endpoint returns all links (active + inactive)
      const res = await axios.get(`${API_URL}/api/settings/personal/links/list`);
      const data = res?.data?.data ?? res?.data ?? [];
      const normalized = Array.isArray(data) ? data.map(x => ({
        id: x.id ?? x.ID ?? x.link_id,
        name: x.name ?? x.title,
        url: x.url ?? x.href,
        color: x.color || 'gold',
        sortOrder: x.sortOrder ?? x.sort_order ?? 0,
        active: typeof x.active === 'boolean' ? x.active : (x.active === 1 || x.active === '1'),
      })) : [];
      dispatch(slice.actions.setLinks(normalized));
    } catch (err) {
      console.error('fetchPersonalLinksAll failed', err);
      dispatch(slice.actions.hasError(err?.response?.data?.message || err.message));
    }
  };
}

export function upsertPersonalLink(link, options = { refresh: true }) {
  const API_URL = process.env.REACT_APP_API_URL;
  return async () => {
    try {
      await axios.post(`${API_URL}/api/settings/personal/links/upsert`, link, { headers: { 'Content-Type': 'application/json' } });
      // Refresh settings list only if requested
      if (options && options.refresh) dispatch(fetchPersonalLinksAll());
      return { success: true };
    } catch (err) {
      console.error('upsertPersonalLink failed', err);
      dispatch(slice.actions.hasError(err?.response?.data?.message || err.message));
      return { success: false, error: err };
    }
  };
}

export function deletePersonalLink(id, options = { refresh: true }) {
  const API_URL = process.env.REACT_APP_API_URL;
  return async () => {
    try {
      await axios.post(`${API_URL}/api/settings/personal/links/delete`, { id }, { headers: { 'Content-Type': 'application/json' } });
      // Refresh settings list only if requested
      if (options && options.refresh) dispatch(fetchPersonalLinksAll());
      return { success: true };
    } catch (err) {
      console.error('deletePersonalLink failed', err);
      dispatch(slice.actions.hasError(err?.response?.data?.message || err.message));
      return { success: false, error: err };
    }
  };
}

export default slice.reducer;


